import $ from 'jquery';

class cdpStatisticsProfilesWithFb{
  constructor() {
    if ($('#cdp-stat-profiles-with-fb').length > 0){
      this.loading()
      this.init()
    }
  }

  init(){
    var cdpStat = this;
    $(document).ready(function() {
      setTimeout(function() {
        var result = { query: JSON.stringify(SegmentQueryBuilder.getMongoQuery()) };
        $.ajax({
          url: $('#cdp-stat-profiles-with-fb').data('url'),
          method: 'GET',
          data: result,
          success: function (response) {
            cdpStat.renderStats(response)
          }
        });
      }, 1000);
    })
  }

  renderStats(response){
    $('#cdp-stat-profiles-with-fb h6').text(`${this.transform(response.profiles_count)} (${this.transform(response.profiles_percentage)}%)`);
    this.loaded();
  }

  loading(){
    $('#cdp-stat-profiles-with-fb').addClass('loading');
  }

  loaded(){
    $('#cdp-stat-profiles-with-fb').removeClass('loading');
  }

  transform(number) {
    return parseFloat(number).toLocaleString("ru")
  }
}

export default cdpStatisticsProfilesWithFb;